import React from "react";
import {
  ButtonContainer,
  EmptyContainer,
  NoMatchingIconContainer,
  TextBold,
  TextSmall,
} from "./emptyState.styles";
import { useSelector } from "react-redux";
import { selectOnlineOrdersConfigs } from "../../../store/kitchen/kitchen.selector";
import { getColor } from "../../../utils/utils.common";
import { NoMatchingIcon } from "../../icons";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";
import { useNavigate, useParams } from "react-router-dom";

interface EmptyStateProps {
  largeText?: string;
  normalText?: string;
  activeBgHeaderModal?: boolean;
  backButton?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  largeText,
  normalText,
  activeBgHeaderModal = false,
  backButton = false,
}) => {
  const onlineOrdersConfig = useSelector(selectOnlineOrdersConfigs);

  const cardBackground = getColor("card-background", onlineOrdersConfig);
  const backgroundSecondary = getColor(
    "background-secondary",
    onlineOrdersConfig
  );
  const textBody = getColor("text-body", onlineOrdersConfig);
  const backgroundTertiary = getColor(
    "background-tertiary",
    onlineOrdersConfig
  );
  const headerModalBackground = getColor(
    "header-modal-background",
    onlineOrdersConfig
  );

  const { kitchenSlug } = useParams();
  const navigate = useNavigate();

  const backHandler = () => {
    navigate(`/${kitchenSlug}`);
  };

  return (
    <EmptyContainer
      cardBackground={cardBackground}
      headerModalBackground={headerModalBackground}
      activeBgHeaderModal={activeBgHeaderModal}
    >
      <NoMatchingIconContainer>
        <NoMatchingIcon
          size="large"
          backgroundSecondary={backgroundSecondary}
          backgroundTertiary={backgroundTertiary}
          textBody={textBody}
        />
      </NoMatchingIconContainer>
      <TextBold textBody={textBody}>{largeText}</TextBold>
      <TextSmall textBody={textBody}>{normalText}</TextSmall>
      {backButton && (
        <ButtonContainer>
          <Button buttonType={BUTTON_TYPE_CLASSES.base} onClick={backHandler}>
            Back to Menu
          </Button>
        </ButtonContainer>
      )}
    </EmptyContainer>
  );
};

export default EmptyState;
